import { taskBoardSlice } from 'data/task-board/slice';

export const { createMatrix, updateMatrix, patchMatrix } =
  taskBoardSlice.actions;
